import { render, staticRenderFns } from "./AccountButton.vue?vue&type=template&id=0b331e00&"
import script from "./AccountButton.ts?vue&type=script&lang=ts&"
export * from "./AccountButton.ts?vue&type=script&lang=ts&"
import style0 from "./AccountButton.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports